module.exports = __webpack_public_path__ + "8527eabe4c13cbbaa9880019b4669a6c.MP3";